// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_container__fUvaW {
  width: 20rem;
}
.Dashboard_container_faqs__MFhvv {
  display: grid;
  grid-template-columns: 1fr;
  padding: 2rem 0;
  gap: 1rem;
  text-align: start;
  color: var(--color-dark-2);
  cursor: pointer;
  font-weight: 700;
}
.Dashboard_container_faqs_option__NI67S:hover {
  transform: translateX(5px);
  transition: 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Dashboard/Dashboard.module.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;AADJ;AAGI;EACI,aAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AADR;AAKY;EACI,0BAAA;EACA,gBAAA;AAHhB","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    width: 20rem;\n\n    &_faqs {\n        display: grid;\n        grid-template-columns: 1fr;\n        padding: 2rem 0;\n        gap: 1rem;\n        text-align: start;\n        color: var(--color-dark-2);\n        cursor: pointer;\n        font-weight: 700;\n\n        &_option {\n\n            &:hover {\n                transform: translateX(5px);\n                transition: 0.2s;\n            }\n        }\n\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Dashboard_container__fUvaW`,
	"container_faqs": `Dashboard_container_faqs__MFhvv`,
	"container_faqs_option": `Dashboard_container_faqs_option__NI67S`
};
export default ___CSS_LOADER_EXPORT___;
